import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

const LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/tentang", label: "About Us", id: "tentang" },
  { to: "/layanan", label: "Services & Products", id: "layanan" },
  { to: "/proyek", label: "Projects", id: "proyek" },
  { to: "/artikel", label: "Articles", id: "blog" },
  { to: "/kontak", label: "Contact", id: "kontak" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200/80 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link
  to="/"
  data-testid="nav-logo"
  className="flex items-center gap-3 group"
>
  <img
    src={COMPANY.logo}
    alt="Logo AJE"
    className="h-9 w-auto transition-transform duration-300 group-hover:scale-105"
  />

  {/* TEXT CONTAINER DENGAN DYNAMIC COLOR BERDASARKAN STATE SCROLLED */}
  <div
    className={`hidden sm:flex flex-col justify-between pl-3 border-l-2 leading-none transition-colors duration-300 ${
      scrolled
        ? "border-slate-900 text-slate-900"
        : "border-white text-white"
    }`}
  >
    <span className="font-sans text-[11px] font-normal tracking-widest block">
      ANEKA
    </span>
    <span className="font-sans text-[11px] font-normal tracking-widest block py-0.5">
      JARINGAN
    </span>
    <span className="font-sans text-[11px] font-normal tracking-widest block">
      ENERGY
    </span>
  </div>
</Link>

          <div className="hidden lg:flex items-center gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.id}`}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${
                    isActive
                      ? "text-blue-900 bg-blue-50"
                      : "text-slate-600 hover:text-blue-900 hover:bg-slate-100/70"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/kontak"
              data-testid="nav-cta-konsultasi"
              className="inline-flex items-center gap-2 rounded-full bg-blue-900 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-900/20 transition-all duration-200 hover:bg-blue-800 hover:-translate-y-0.5"
            >
              <Phone className="h-4 w-4" /> Book Your Free Consultation
            </Link>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center rounded-full p-2 text-blue-900 bg-white/70 border border-slate-200"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-slate-100 px-4 pb-6 pt-2 shadow-xl"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-link-${l.id}`}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl text-base font-semibold transition-colors ${
                  isActive
                    ? "text-blue-900 bg-blue-50"
                    : "text-slate-700 hover:bg-slate-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/kontak"
            data-testid="mobile-nav-cta"
            className="mt-3 flex items-center justify-center gap-2 rounded-full bg-blue-900 px-5 py-3 text-sm font-semibold text-white"
          >
            <Phone className="h-4 w-4" /> Book Your Free Consultation
          </Link>
        </div>
      )}
    </header>
  );
}
